import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import { useStateContext } from '../../Contexts/ContextProvider';

const QuizResults = () => {
  const { id, quizId } = useParams();
  const { SetNotification } = useStateContext();
  const [quiz, setQuiz] = useState(null);
  const [loading, setLoading] = useState(true);
  const timerRef = useRef(null);

  const fetchResults = async () => {
    try {
      const response = await AxiosClient.get(`/sessions/${id}/quizzes/${quizId}/results`);
      setQuiz(response.data.quiz);
    } catch (error) {
      SetNotification('Error loading results', 'danger');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResults();
    timerRef.current = setInterval(fetchResults, 3000);
    return () => clearInterval(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, quizId]);

  if (loading) return <h6 className="m-3">loading ..</h6>;
  if (!quiz) return <h6 className="m-3">Quiz not found</h6>;

  const totalVotes = (quiz.options || []).reduce((sum, o) => sum + (o.votes_count || 0), 0);

  return (
    <div className="m-4">
      <h3>{quiz.question}</h3>
      <p className="text-muted">
        Status: {quiz.is_published ? (quiz.is_closed ? 'Closed' : 'Live') : 'Draft'} |
        Total votes: {totalVotes}
      </p>

      {quiz.options && quiz.options.map((o) => {
        const pct = totalVotes > 0 ? Math.round((o.votes_count / totalVotes) * 100) : 0;
        return (
          <div key={o.id} className="mb-3">
            <div className="d-flex justify-content-between">
              <span>{o.option_text}</span>
              <span>{o.votes_count || 0} ({pct}%)</span>
            </div>
            <div className="progress" style={{ height: '22px' }}>
              <div
                className="progress-bar bg-info"
                role="progressbar"
                style={{ width: `${pct}%` }}
                aria-valuenow={pct}
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {pct}%
              </div>
            </div>
          </div>
        );
      })}

      <p className="text-muted mt-3">Results auto-refresh every 3 seconds.</p>
    </div>
  );
};

export default QuizResults;
